import { type SVGProps } from 'react';

import { withDynamicStroke } from '../../withDynamicStroke';
const Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M3 18h-.75zM3 6h.75zm4-4v-.75zm10 0v-.75zm4 4h-.75zm0 6.343h.75zM11.343 22v-.75zM7 22v.75zm12.828-6.828-.53-.53zm-5.656 5.656.53.53zM13 18h-.75zm4-4v-.75zM8.47 8.47a.75.75 0 0 0 1.06 1.06zm2.116-1.056.53.53zm2.828 0-.53.53zM14.47 9.53a.75.75 0 1 0 1.06-1.06zM12.75 7a.75.75 0 0 0-1.5 0zm-1.5 5a.75.75 0 0 0 1.5 0zm-7.5 6V6h-1.5v12zM7 2.75h10v-1.5H7zM20.25 6v6.343h1.5V6zm-8.907 15.25H7v1.5h4.343zm7.955-6.609-5.657 5.657 1.06 1.06 5.658-5.656zm-7.955 8.109c1.26 0 2.468-.5 3.359-1.391l-1.06-1.06a3.25 3.25 0 0 1-2.299.951zm8.907-10.407a3.25 3.25 0 0 1-.952 2.298l1.06 1.06a4.75 4.75 0 0 0 1.392-3.358zM3.75 6A3.25 3.25 0 0 1 7 2.75v-1.5A4.75 4.75 0 0 0 2.25 6zm-1.5 12A4.75 4.75 0 0 0 7 22.75v-1.5A3.25 3.25 0 0 1 3.75 18zM17 2.75A3.25 3.25 0 0 1 20.25 6h1.5A4.75 4.75 0 0 0 17 1.25zM13.75 22v-4h-1.5v4zM17 14.75h4v-1.5h-4zM13.75 18A3.25 3.25 0 0 1 17 14.75v-1.5A4.75 4.75 0 0 0 12.25 18zM9.53 9.53l1.586-1.585-1.06-1.061L8.47 8.47zm3.354-1.585L14.47 9.53l1.06-1.06-1.585-1.586zM11.25 7v5h1.5V7zm-.134.945a1.25 1.25 0 0 1 1.768 0l1.06-1.061a2.75 2.75 0 0 0-3.889 0z"
    />
  </svg>
);
export const IconFileDownload = withDynamicStroke(Icon);
